export const CHANGE_MATCH_ANALYSIS_FILTER_JP = "CHANGE_MATCH_ANALYSIS_FILTER_JP";
export const RESET_MATCH_ANALYSIS_FILTER_JP = "RESET_MATCH_ANALYSIS_FILTER_JP";

const initialState = {
  matchAnalysisName:"",
  fromJp:true,
  job_position_id: null,
  selectedJobPositions: [],
  selectedJobPositionNames: null,
  notes_query: "",
  state:"",
  applicant_name:"",
  application_id:null,
  applicant_names:null,
  selectedJobApplications:[]
};

export default function matchAnalysisByJPFilterReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_MATCH_ANALYSIS_FILTER_JP:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_MATCH_ANALYSIS_FILTER_JP:
      return initialState;

    default:
      return state;
  }
}
